import React from 'react';
import Recorder from 'components/organismos/Recorder';
import { useHistory } from "react-router-dom";
import { checkPermissionAccessRecorder } from 'hooks/checkPermissionAcess'
import Appbar from 'components/organismos/Appbar';
const RecorderPage = () => {
  const history = useHistory();

  if(!checkPermissionAccessRecorder()){
    history.push('/404');
  }
  return (
  <React.Fragment>
    <Appbar/>
    <Recorder/>
  </React.Fragment>
  )
};

export default RecorderPage;
